import { PrimaryCareProviderAssets } from './types/pcp-library.types';

import backgrayIcon from './assets/cp_back_icon.svg';
import infoIcon from './assets/info.svg';
import serviceIcon from './assets/service.svg';

export const PRIMARY_CARE_LIBRARY_ASSET_KEYS: PrimaryCareProviderAssets = {
  BACK_GRAY_ICON: backgrayIcon,
  INFO_ICON: infoIcon,
  SERVICE_DOWN_ICON: serviceIcon,
};
